String.prototype.squish = function() {
  return this.trim().replace(/\s+/g, ' ')
}
